import React from 'react'
import styled from 'styled-components'
import { BackToSearch } from '../BackToSearch'
import { SchoolDetailsPageNavigation } from './SchoolDetailsPageNavigation'
import { Toolbar, ToolbarLeft, ToolbarRight } from '../../components/Toolbar'
import { STYLES } from '../../static/style'

const ToolbarContainer = styled.div`
  height: 50px;
`

const StyledSchoolDetailsToolbar = styled(Toolbar)`
  position: fixed;
  z-index: 1;
  background-color: ${STYLES.COLOR_OUTER_SPACE_GRAY};
  border-bottom-color: ${STYLES.COLOR_OUTER_SPACE_GRAY};
`

interface ISchoolDetailsToolbarProps {
  schoolId: string
  onPrevClick: (index: number) => void
  onNextClick: (index: number) => void
}

const SchoolDetailsToolbar: React.FC<ISchoolDetailsToolbarProps> = ({
  schoolId,
  onNextClick,
  onPrevClick,
}) => (
  <ToolbarContainer>
    <StyledSchoolDetailsToolbar>
      <ToolbarLeft>
        <BackToSearch />
      </ToolbarLeft>
      <ToolbarRight>
        <SchoolDetailsPageNavigation
          schoolId={schoolId}
          onNextClick={onNextClick}
          onPrevClick={onPrevClick}
        />
      </ToolbarRight>
    </StyledSchoolDetailsToolbar>
  </ToolbarContainer>
)

export { SchoolDetailsToolbar }
